export const ZONE_COLORS = {
  autoAccept: '#c4b5fd',
  manual: '#8b5cf6',
  autoReject: '#6b7280',
} as const

export const GRADIENT_BLEND = 3.5
